import {ErrorSection as ErrorSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/sections.types';
import {useTrackOspError} from '@aboutyou/tracking';
import {
  Button,
  COLORS,
  desktopAndUpLinaria,
  FONT_SIZES,
  GenericIconName,
  MessageBox,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useEffect} from 'react';

export const ErrorSection = (props: {error: ErrorSectionType}) => {
  const {error} = props;

  const trackError = useTrackOspError();

  useEffect(() => {
    trackError(props.error.errorMessage);
  }, []);

  return (
    <ErrorSectionStreamWrapper>
      <MessageBox
        backgroundColor="Orange100"
        iconColor="Orange600"
        icon={GenericIconName.Warning}
        data-testid="errorSection"
      >
        <ErrorSectionContentWrapper>
          <TitleWrapper>
            <Headline weight="mediumHeavy">{error.headline}</Headline>
            <Subtitle>{error.subtitle}</Subtitle>
          </TitleWrapper>
          <StyledButton variant="secondary" href="/a/orders" size="fit-width">
            {error.ctaLabel}
          </StyledButton>
        </ErrorSectionContentWrapper>
      </MessageBox>
    </ErrorSectionStreamWrapper>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${desktopAndUpLinaria(`
    gap: 0.5rem;
  `)}
`;

const Headline = styled(Text)`
  line-height: 1.5rem;
  font-size: ${FONT_SIZES.px20};

  ${desktopAndUpLinaria(`
    font-size: ${FONT_SIZES.px32};
    line-height: 2.5rem;
  `)}
`;

const Subtitle = styled(Text)`
  line-height: 1.125rem;
  font-size: ${FONT_SIZES.px12};

  ${desktopAndUpLinaria(`
    font-size: ${FONT_SIZES.px14};
    line-height: 1.25rem;
  `)}
`;

export const ErrorSectionStreamWrapper = styled.div`
  background-color: ${COLORS.White};
  padding: 1rem 1rem 1.5rem;

  ${desktopAndUpLinaria(`
    padding: 1rem 0 1.5rem;
  `)}
`;

const StyledButton = styled(Button)`
  &&&& {
    margin-top: 1rem;
    --background-color: ${COLORS.Orange100};

    ${desktopAndUpLinaria(`
      margin-top: unset;
    `)}
  }
`;

const ErrorSectionContentWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${desktopAndUpLinaria(`
    flex-direction: row;
    text-align: unset;
    gap: 2rem;
    padding: 0;
  `)}
`;
